<template>
  <!-- 展览详情 -->
  <div class="page-exbition-detail">
    <!-- <div class="g-line"></div> -->
    <div class="intro g-content-wrap g-pad-top g-detail-page">
      <h1 class="tc m-font-1" style="margin:0 auto;">{{detailData.title}}</h1>
      <p class="time tc m-font-2">{{detailData.createTimeStr}}</p>

      <div class="g-detail-html trans" v-html="detailData.content"></div>
    </div>
  </div>
</template>

<script>
import videoPlayer from '@cmp/video-player'
export default {
  components: { videoPlayer },
  data() {
    return {
      pageType: this.$route.query.pageType,  // 5辽博讲堂 6资讯
      titleObj: {
        '1': '',
        '2': '',
        '3': '图录简介',
        '4': '',
        '5': '讲座内容',
      },
      activeVal: '2',
      tabList: [
        {
          name: '展厅实景',
          val: '1'
        },
        {
          name: '展品详情',
          val: '2'
        }
      ],
      detailData: {
        content: ''
      },
      detailId: this.$route.query.id,
      stopVideo: false
    }
  },
  methods: {
    getDetailData() {
      this.$http
        .get('../singleMuseum/webapi/commondetail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getDetailDataClass() {
      this.$http
        .get('../singleMuseum/applet/classRoom/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    setBread() {
      // 动态修改面包屑 2 资讯  6 制度建设
      console.log('00', this.pageType)
      switch(this.pageType) {
        case '2':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '资讯',
              href: '/about?pageType=2'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '6':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '制度建设',
              href: '/about?pageType=6'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
      }
    }
  },
  created() {
    this.setBread()
    if(this.pageType === '5') {
      this.getDetailDataClass()
    } else {
      this.getDetailData()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-exbition-detail {
  h1 {
    // font-size: 28px;
    // font-weight: bold;
    color: #000;
  }
  .time {
    color: #999493;
    margin-top: 20px;
    margin-bottom: 40px;
  }
}
</style>

